import React, {
  FC, useEffect, useState,
} from 'react';
import { FaChevronLeft } from 'react-icons/fa6';
import {
  BackgroundImage,
  Row, Button, Column,
} from './Styles';
import Header from '../../../../../Common/Header';
import { Box, Cab } from '../../../../../../../lib/types';
import { updateFoodifoxData } from '../../../../../../../lib/axios/FoodifoxDataAPI';
import NoticeModal from './NoticeModal';
import NoFreeBoxModal from '../../../../../Common/NoFreeBoxModal';
import Image from '../../../../../../../components/Image';
import { redRoundWarning } from '../../../../../../../assets/Svg';
import { addSystemLog } from '../../../../../../../lib/SystemLogUtils';
import { getCabId } from '../../../../../../../lib/utils/utils';

const OpenBox: FC<Props> = ({
  cabId32Str,
  setTargetPage,
  isEnglish,
  setIsEnglish,
  cab,
  setShowLoading,
  platform,
  driverId,
  setPickupRoomNo,
  setOrderId,
  setSelectedPlatform,
  setOpenedBoxes,
}) => {
  const [openBoxLazy, { loading: openBoxLoading }] = updateFoodifoxData<{ orderId: number; cabSizeType: string; openBoxes: Box[] }>('/foxH5RentBox/rentBoxByRoomNo');

  const [roomNo, setRoomNo] = useState<string>();
  const [showNoticeModal, setShowNoticeModal] = useState<boolean>();
  const [showNoFreeBoxModal, setShowNoFreeBoxModal] = useState<boolean>();

  useEffect(() => {
    setShowLoading(openBoxLoading);

    return () => {
      setShowLoading(false);
    };
  }, [openBoxLoading]);

  /**
   * 租用柜门
   */
  const openBox = () => {
    if (roomNo == null || roomNo.trim().length === 0) {
      return;
    }

    openBoxLazy({
      param: {
        driverId,
        platform,
        roomNo,
        cabId: cabId32Str,
      },
      onError() {
        setShowNoFreeBoxModal(true);
      },
      onCompleted({ orderId, openBoxes }) {
        setPickupRoomNo(roomNo);
        setOrderId(orderId);
        setOpenedBoxes(openBoxes);
        setTargetPage('room-num-open-box-success');
        addSystemLog(getCabId(cabId32Str), '', platform + '', '骑手ID：' + driverId + '，租用柜门：' + JSON.stringify(openBoxes.map((box) => box.boxNumber)) + '，房间号：' + roomNo);
      },
    });
  };

  return (
    <BackgroundImage>
      {
        showNoticeModal && (
          <NoticeModal isEnglish={isEnglish} onClose={() => setShowNoticeModal(false)} />
        )
      }
      {
        showNoFreeBoxModal && (
          <NoFreeBoxModal
            onClose={() => {
              setShowNoFreeBoxModal(false);
            }}
            isEnglish={isEnglish}
          />
        )
      }
      {/* 头部 */}
      <Header
        isEnglish={isEnglish}
        setIsEnglish={setIsEnglish}
        style={{ marginTop: '50px' }}
        setTargetPage={setTargetPage}
        supportIsOnlyCall={true}
        cabId32Str={cabId32Str}
      />

      {/* 返回箭头 */}
      <Button
        style={{ marginLeft: '15px', marginTop: '10px' }}
        onClick={() => {
          setSelectedPlatform(undefined);
          setTargetPage('platform-select');
        }}
      >
        <FaChevronLeft style={{ fontSize: '20px', marginTop: '7px', color: '#11202B' }} />
      </Button>

      {/* 提示输入客人房间号 */}
      <div style={{ marginTop: '25px', marginLeft: 'auto', marginRight: 'auto', textAlign: 'center' }}>
        {
          isEnglish ? (
            <span style={{ fontSize: '18px', fontFamily: 'Squad-Regular, Squad', fontWeight: 400, color: '#11202B', lineHeight: '25px' }}>
              Please enter the  Recipient’s unit no.
            </span>
          ) : (
            <span style={{ fontSize: '18px', fontFamily: 'PingFangSC-Regular, PingFang SC', fontWeight: 400, color: '#11202B', lineHeight: '25px' }}>
              请输入取餐人的公寓门牌号
            </span>
          )
        }
      </div>

      {/* 房间号标题 */}
      <Row style={{ marginTop: '25px', marginLeft: 'auto', marginRight: 'auto', justifyContent: 'center', alignItems: 'center' }}>
        {
          isEnglish ? (
            <>
              <Column>
                <Image srcImg={redRoundWarning} onClick={() => setShowNoticeModal(true)} style={{ width: '20px', height: '20px', marginRight: '6px', marginTop: '-4px' }} />
              </Column>
              <Column>
                <span style={{ fontSize: '26px', fontFamily: 'Squad-Bold, Squad', fontWeight: 'bold', color: '#11202B', lineHeight: '34px' }}>
                  Unit No.
                </span>
              </Column>
            </>
          ) : (
            <>
              <Column>
                <Image srcImg={redRoundWarning} onClick={() => setShowNoticeModal(true)} style={{ width: '20px', height: '20px', marginRight: '6px' }} />
              </Column>
              <Column>
                <span style={{ fontSize: '26px', fontFamily: 'PingFangSC-SemiBold, PingFang SC', fontWeight: 600, color: '#11202B', lineHeight: '37px' }}>
                  门牌号
                </span>
              </Column>
            </>
          )
        }
      </Row>

      {/* 房间号 */}
      <div>
        <Column style={{ width: '85%', height: '86px', background: '#ffffff', borderRadius: '43px', border: '1px solid #11202B', margin: '10px auto 0 auto' }}>
          <input
            autoFocus={true}
            style={{
              width: '250px',
              border: 'none',
              outline: 'none',
              fontSize: '36px',
              fontFamily: 'Squad-Bold, Squad',
              fontWeight: 'bold',
              color: '#11202B',
              lineHeight: '48px',
              letterSpacing: '6px',
              backgroundColor: '#ffffff',
              textAlign: 'center',
              borderRadius: '43px',
            }}
            type="text"
            placeholder={'e.g.1111'}
            value={roomNo}
            onChange={(e) => setRoomNo(e.target.value)}
          />
        </Column>
      </div>

      {/* 地址标题 */}
      <Row style={{ marginTop: '35px', marginLeft: 'auto', marginRight: 'auto', justifyContent: 'center', alignItems: 'center' }}>
        {
          isEnglish ? (
            <>
              <span style={{ fontSize: '18px', fontFamily: 'Squad-Bold, Squad', fontWeight: 'bold', color: '#11202B', lineHeight: '24px' }}>
                Address
              </span>
            </>
          ) : (
            <>
              <span style={{ fontSize: '18px', fontFamily: 'PingFangSC-SemiBold, PingFang SC', fontWeight: 600, color: '#11202B', lineHeight: '25px' }}>
                地址
              </span>
            </>
          )
        }
      </Row>

      {/* 地址 */}
      <Column style={{ marginTop: '10px', marginLeft: 'auto', marginRight: 'auto', justifyContent: 'center', alignItems: 'center' }}>
        <div style={{ maxWidth: '317px', fontSize: '18px', fontFamily: 'Squad-Regular, Squad', fontWeight: 400, color: '#11202B', lineHeight: '24px', whiteSpace: 'normal', wordBreak: 'break-all', textAlign: 'center' }}>
          {cab.cabName}
        </div>
      </Column>

      <Button
        disabled={!roomNo}
        onClick={() => openBox()}
        style={{ width: '114px', height: '114px', borderRadius: '50%', border: roomNo ? '2px solid #11202B' : undefined, background: roomNo ? '#01B596' : '#D0D0D0', marginLeft: 'auto', marginRight: 'auto', marginTop: '70px' }}
      >
        {
          isEnglish ? (
            <div style={{ fontSize: '25px', fontFamily: 'Squad-Bold, Squad', fontWeight: 'bold', color: '#FFFFFF', lineHeight: '33px' }}>
              Open
            </div>
          ) : (
            <div style={{ fontSize: '25px', fontFamily: 'PingFangSC-SemiBold, PingFang SC', fontWeight: 600, color: '#FFFFFF', lineHeight: '30px' }}>
              开柜
            </div>
          )
        }
      </Button>
    </BackgroundImage>
  );
};

export interface Props {
  cabId32Str: string;
  setTargetPage: (targetPage: string) => void;
  isEnglish: boolean;
  setIsEnglish: (isEng: boolean) => void;
  cab: Cab;
  driverId: number;
  platform: number;
  setOrderId: (id?: number) => void;
  setShowLoading: (isShow: boolean) => void;
  setPickupRoomNo: (roomNo: string) => void;
  setSelectedPlatform: (platform?: number) => void;
  setOpenedBoxes: (openedBoxes: Box[]) => void;
}

export default OpenBox;
